"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
var material_1 = require("@mui/material");
/** Basic MUI loading button but with our specific styling */
exports.Component = (0, material_1.styled)(LoadingButton_1.default)({
    borderRadius: '8px',
    textTransform: 'none',
    '&.MuiButton-outlinedSecondary': {
        border: '1px solid #E0E0E0',
        '&:hover': {
            border: '1px solid #BDBDBD',
        },
    },
    '&.MuiButton-sizeSmall': {
        fontSize: '0.6875rem',
        fontWeight: 500,
        lineHeight: '1.375rem',
    },
    '&.MuiButton-sizeMedium': {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
    },
    '&.MuiButton-sizeLarge': {
        fontSize: '0.9375rem',
        fontWeight: 500,
        lineHeight: '1.625rem',
    },
});
